export default "__VITE_ASSET__Bk4HjOKL__"